// extracted by mini-css-extract-plugin
module.exports = {"AdArea":"AdArea_AdArea__3e7_R","AdAreaSeparator":"AdArea_AdAreaSeparator__3aGp6","AdText":"AdArea_AdText__bp96p"};